<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "CompanyGroupForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {},
      isBusy: false
    };
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item
          };
          this.isBusy = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CompanyGroup/CompanyGroupForm.vue